import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import Loader from "../components/Loader";
import ViewModal from "../components/ViewModal";

const BASE_URL = process.env.REACT_APP_BASE_URL;
const apiKey = process.env.REACT_APP_API_KEY;

export default function Rebuttals() {
  const { country } = useParams();
  const role = Cookies.get("user_role");
  const isAdmin = role === "Administrator";

  const [loading, setLoading] = useState(true);
  const [rebuttals, setRebuttals] = useState([]);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [query, setQuery] = useState("");
  const [viewOpen, setViewOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  const headers = {
    Authorization: apiKey,
    "Content-Type": "application/json",
  };

  const loadRebuttals = () => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/getrebuttals/${encodeURIComponent(country)}`, { headers })
      .then((res) => {
        setRebuttals(res.data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error fetching rebuttals:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    loadRebuttals();
  }, [country]);

  const resetForm = () => {
    setTitle("");
    setContent("");
    setEditingId(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!title.trim() || !content.trim()) {
      alert("Title and rebuttal are required.");
      return;
    }

    if (editingId) {
      axios
        .put(
          `${BASE_URL}/updaterebuttal`,
          { Id: editingId, Title: title.trim(), Rebuttal: content.trim() },
          { headers }
        )
        .then(() => {
          resetForm();
          loadRebuttals();
        })
        .catch((err) => console.log("Error updating rebuttal:", err));
      return;
    }

    axios
      .post(
        `${BASE_URL}/addrebuttal`,
        { Country: country, Title: title.trim(), Rebuttal: content.trim() },
        { headers }
      )
      .then(() => {
        resetForm();
        loadRebuttals();
      })
      .catch((err) => console.log("Error adding rebuttal:", err));
  };

  const handleEdit = (item) => {
    setEditingId(item.Id);
    setTitle(item.Title);
    setContent(item.Rebuttal);
  };

  const handleDelete = (id) => {
    const confirmDelete = window.confirm("Delete this rebuttal?");
    if (!confirmDelete) return;

    axios
      .delete(`${BASE_URL}/deleterebuttal/${id}`, { headers })
      .then(() => {
        if (editingId === id) {
          resetForm();
        }
        loadRebuttals();
      })
      .catch((err) => console.log("Error deleting rebuttal:", err));
  };

  const copyText = async (item) => {
    try {
      await navigator.clipboard.writeText(`${item.Title}\n\n${item.Rebuttal}`);
      alert("Copied to clipboard.");
    } catch (error) {
      console.log("Copy failed:", error);
    }
  };

  const downloadText = (item) => {
    const text = `${item.Title}\n\n${item.Rebuttal}`;
    const blob = new Blob([text], { type: "text/plain;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${country}-${item.Title}`.replace(/[^\w-]+/g, "_") + ".txt";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  const filtered = rebuttals.filter((item) => {
    const q = query.toLowerCase();
    return (
      item.Title.toLowerCase().includes(q) || item.Rebuttal.toLowerCase().includes(q)
    );
  });

  if (loading) return <Loader />;

  return (
    <div className="container">
      <h2>{country} - Rebuttles</h2>
      <br />

      {isAdmin && (
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-sm-4">
              <input
                type="text"
                className="form-control"
                placeholder="Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </div>
            <div className="col-sm-8">
              <textarea
                className="form-control"
                rows="3"
                placeholder="Write rebuttal..."
                value={content}
                onChange={(e) => setContent(e.target.value)}
              />
            </div>
          </div>
          <br />
          <button className="btn btn-primary" type="submit">
            {editingId ? "Update Rebuttal" : "Add Rebuttal"}
          </button>
          {editingId && (
            <button
              className="btn btn-secondary ms-2"
              type="button"
              onClick={resetForm}
            >
              Cancel
            </button>
          )}
          <br />
          <br />
        </form>
      )}

      <div className="row">
        <div className="col-sm-4">
          <input
            type="text"
            className="form-control"
            placeholder="Search rebuttles..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>
      </div>
      <br />

      <table className="table table-striped table-dark crm-table">
        <thead>
          <tr>
            <th>Title</th>
            <th>Rebuttal</th>
            <th className="crm-col-actions">View</th>
            <th>Created At</th>
            <th className="crm-col-actions">Copy</th>
            <th className="crm-col-actions">Download</th>
            {isAdmin && (
              <>
                <th className="crm-col-actions">Update</th>
                <th className="crm-col-actions">Delete</th>
              </>
            )}
          </tr>
        </thead>
        <tbody>
          {filtered.map((item) => (
            <tr key={item.Id}>
              <td>{item.Title}</td>
              <td className="crm-cell-box">
                <div className="crm-preview" style={{ whiteSpace: "pre-wrap" }}>
                  {item.Rebuttal}
                </div>
              </td>
              <td className="crm-col-actions">
                <button
                  className="btn btn-sm btn-light crm-icon-btn"
                  onClick={() => {
                    setSelected(item);
                    setViewOpen(true);
                  }}
                  title="View"
                >
                  <i className="bi bi-eye"></i>
                </button>
              </td>
              <td>{item.Created_At}</td>
              <td className="crm-col-actions">
                <button
                  className="btn btn-sm btn-info crm-icon-btn"
                  onClick={() => copyText(item)}
                  title="Copy"
                >
                  <i className="bi bi-clipboard"></i>
                </button>
              </td>
              <td className="crm-col-actions">
                <button
                  className="btn btn-sm btn-warning crm-icon-btn"
                  onClick={() => downloadText(item)}
                  title="Download"
                >
                  <i className="bi bi-download"></i>
                </button>
              </td>
              {isAdmin && (
                <>
                  <td className="crm-col-actions">
                    <button
                      className="btn btn-sm btn-light crm-icon-btn"
                      onClick={() => handleEdit(item)}
                      title="Edit"
                    >
                      <i className="bi bi-pencil-square"></i>
                    </button>
                  </td>
                  <td className="crm-col-actions">
                    <button
                      className="btn btn-sm btn-danger crm-icon-btn"
                      onClick={() => handleDelete(item.Id)}
                      title="Delete"
                    >
                      <i className="bi bi-trash3"></i>
                    </button>
                  </td>
                </>
              )}
            </tr>
          ))}
          {filtered.length === 0 && (
            <tr>
              <td colSpan={isAdmin ? 8 : 6} className="text-center">
                No rebuttals found.
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <ViewModal
        open={viewOpen}
        title={selected ? `Rebuttal - ${selected.Title}` : "Rebuttal"}
        onClose={() => setViewOpen(false)}
      >
        {selected && (
          <>
            <div className="mb-2 text-muted">
              <div>
                <strong>Country:</strong> {country}
              </div>
              <div>
                <strong>Created At:</strong> {selected.Created_At}
              </div>
            </div>
            <div
              className="p-3"
              style={{
                border: "1px solid #e5e5e5",
                borderRadius: "10px",
                whiteSpace: "pre-wrap",
              }}
            >
              {selected.Rebuttal}
            </div>
          </>
        )}
      </ViewModal>
    </div>
  );
}
